export const cgu = `<div class="page">
  <h1 class="title">
    Conditions Générales d'Utilisation
  </h1>

  <h2>
    <strong>1. Préambule</strong>
  </h2>
  <p>
    Le site fibre-zen.fr est un site de la société WEEDEV. La société WEEDEV, société par actions simplifiées, est spécialisée en marketing digital. Son siège social se situe au 114 rue Gallieni, 92100 Boulogne-Billancourt, elle est immatriculée au Registre des Commerces et des Sociétés avec comme numéro SIREN : 820 561 538, dont le Président est Value Invest Holding, représentée par son gérant Léo Hauet.
  </p>

  <h2>
    <strong>2. Définitions</strong>
  </h2>
  <p>
    Le terme « CGU » désigne les présentes Conditions Générales d'Utilisation.
  </p>
  <p>
    La « Société » désigne WEEDEV SAS, créateur et propriétaire du Site.
  </p>
  <p>
    Est un « Utilisateur » toute personne physique qui utilise le Site, et qui cherche à entrer en contact avec un Professionnel pour l'achat d'un bien ou d'une prestation de services, au travers de la mise en relation par WEEDEV SAS.
  </p>
  <p>
    Est un « Professionnel » toute personne physique ou morale, publique ou privée, qui agit à des fins entrant dans le cadre de son activité commerciale, industrielle, artisanale, libérale ou agricole et fait appel à la Société aux fins de la création ou de l'utilisation d'un Site de mise en relation avec des Utilisateurs susceptibles d'être intéressés par les produits ou les services proposés par le Professionnel.
  </p>
  <p>
    L'Utilisateur sera potentiellement amené à devenir un « Client » du Professionnel en cas de contrat conclu entre lui et ce dernier.
  </p>
  <p>
    Est la "Législation Applicable" toute norme ou réglementation se rapportant à l'activité de navigation sur un Site en ligne, et notamment sans s'y limiter, l'ensemble des règles liées à la propriété intellectuelle, ainsi que celles contenues dans la loi pour la confiance dans l'économie numérique du 21 juin 2004.
  </p>

  <h2>
    <strong>3. Objet</strong>
  </h2>
  <p>
    Les présentes CGU ont pour objet de régir les relations entre la Société, d'une part, et les Utilisateurs qui ont recours ou accèdent simplement au Site, d'autre part.
  </p>
  <p>
    En conséquence, le fait d'utiliser le Site emporte le consentement entier et sans réserves de l'Utilisateur aux présentes CGU. A cet effet, la Société invite l'Utilisateur à lire attentivement les CGU. L'Utilisateur déclare et garantit avoir lu et compris les CGU.
  </p>

  <h2>
    <strong>4. Prestation de la Société</strong>
  </h2>
  <p>
    La Société met en relation l'Utilisateur avec le Professionnel. Pour être mis en relation avec un Professionnel l'Utilisateur devra remplir l'interface prévue à cet effet et remplir tous les champs indiqués avec un astérisque (*).
  </p>
  <p>
    L'Utilisateur qui est un consommateur au sens de l'article liminaire du code de la consommation, renonce expressément à son droit de rétractation et demande l'exécution immédiate du contrat de mise en relation avec un Professionnel, de téléchargement d'un guide ou encore de simulation au sens de l'article L. 221-25 du code de la consommation en remplissant les champs prévus à cet effet et en cliquant sur le bouton « envoyer ».
  </p>
  <p>
    La liste de nos Partenaires est disponible dans notre Politique de confidentialité.
  </p>

  <h2>
    <strong>5. Accessibilité du Site</strong>
  </h2>
  <p>
    La Société fera tout son possible pour maintenir le Site accessible et performant sans retard ou difficultés excessives.
  </p>
  <p>
    Toutefois, la Société ne peut pas garantir un fonctionnement sans interruptions ni dérangements de l'accès au Site. En particulier, la Société peut être amenée à réaliser des travaux d'entretien et des mises à jour de son Site pour adapter son contenu et/ou intégrer les évolutions des services et des fonctionnalités qui y sont proposés, susceptibles d'interrompre temporairement son accès, sans que ses interruptions ne soient considérées comme un manquement de la Société à ses obligations.
  </p>
  <p>
    La Société s'engage à ce que le Site soit accessible, mais ne pourra être tenu responsable en cas de bug ou d'inaccessibilité résultant d'un fournisseur d'accès internet, d'une mauvaise couverture internet ou encore d'un cas de force majeure.
  </p>
  <p>
    Tout Utilisateur présent sur le Site est présumé majeur jusqu'à preuve du contraire.
  </p>

  <h2>
    <strong>6. Utilisation et navigation Licite du Site</strong>
  </h2>
  <p>
    L'Utilisateur s'engage à utiliser le Site de manière licite et raisonnable, et à ne pas détourner des fonctionnalités que celui-ci propose.
  </p>
  <p>
    La responsabilité de la Société ne pourra pas être engagée pour toute utilisation détournée du Site par l'Utilisateur, en dehors des fonctionnalités prévues.
  </p>
  <p>
    L'Utilisateur est informé que sa responsabilité pourra être engagée à la hauteur des préjudices subis par la Société conformément à l'article 8 des Présentes.
  </p>

  <h2>
    <strong>7. Prix</strong>
  </h2>
  <p>
    L'accès au Site et le service de mise en relation entre l'Utilisateur et le Professionnel est gratuit.
  </p>

  <h2>
    <strong>8. Responsabilité</strong>
  </h2>
  <h3>8.1. Responsabilité de la Société</h3>
  <p>
    La Société s'engage à exécuter ses obligations de moyens de bonne foi. Toutefois, elle ne pourra être tenue pour responsable si l'inexécution de ses obligations résulte de la faute d'un tiers, de la faute de l'Utilisateur ou du Professionnel ou d'un cas de force majeure.
  </p>
  <p>
    La Société veille à ce que le contenu du Site respecte les lois et règlements en vigueur.
  </p>

  <h3>8.2. Responsabilité de l'Utilisateur</h3>
  <p>
    L'Utilisateur s'engage à ne pas utiliser le Site en violation des lois ou règlements en vigueur, et notamment sans s'y limiter à ne pas réaliser d'actes de parasitisme ou de concurrence déloyale.
  </p>
  <p>
    L'Utilisateur est responsable des dommages, directs et indirects, qui lui seraient imputables et notamment en cas de manquement à ses obligations au titre de la des Présentes ou à la Législation Applicable.
  </p>
  <p>
    Par ailleurs, la Société se réserve le droit d'engager la responsabilité civile et/ou pénale de l'Utilisateur.
  </p>
  <p>
    L'Utilisateur reconnaît que :
  </p>
  <ul>
    <li>La Société n'est tenue que d'une obligation de moyens pour l'ensemble des services qu'elle propose ;</li>
    <li>La Société n'intervient pas dans les échanges entre le Professionnel et l'Utilisateur ;</li>
    <li>La Société décline toute responsabilité pour tout litige intervenant entre le Professionnel et l'Utilisateur, quelle qu'en soit la cause.</li>
  </ul>

  <h2>
    <strong>9. Propriété intellectuelle</strong>
  </h2>
  <p>
    Le Site dans son ensemble et chacun des éléments visuels ou sonores qui le composent (à savoir notamment les marques, les logos, les dessins et modèles, les illustrations, les photographies, les textes, les animations, les vidéogrammes, les phonogrammes, les logiciels, codes sources et les bases de données) sont la propriété exclusive de la Société et/ou des titulaires des droits de propriété intellectuelle concernés. Tous ces éléments sont protégés au titre de la propriété intellectuelle et notamment par le droit d'auteur, le droit des marques, et le droit des dessins et modèles, le droit des brevets ainsi que des droits sui generis.
  </p>
  <p>
    En conséquence, toute reproduction, communication, téléchargement, modification ou utilisation totale ou partielle de l'un de ces éléments appartenant à la Société ou à un tiers, pour quelque motif et pour quelque support que ce soit, nécessite l'autorisation écrite et préalable de la Société ou de leurs titulaires, sauf lorsque la loi l'y autorise. A défaut de cette autorisation, toute représentation totale ou partielle du site et des éléments le composant, par quelque procédé que ce soit, est interdite et constituerait soit une contrefaçon sanctionnée par les article L.122-4 et suivants du Code de la propriété intellectuelle, soit un acte de concurrence déloyale sanctionné par l'article 1240 du Code civil.
  </p>
  <p>
    Les marques de la Société et de ses partenaires, ainsi que les logos figurant sur le Site sont des marques (semi-figuratives ou non) déposées. Toute reproduction ou représentation totale ou partielle de ces marques, toute modification, toute altération de ces marques et/ou logos sans l'autorisation expresse de la Société sont donc prohibées, au sens de l'article L. 713-2 du Code de la propriété intellectuelle.
  </p>
  <p>
    L'Utilisateur déclare et garantit être informé qu'en cas de manquement à l'une quelconque de ces obligations, il s'expose à des poursuites judiciaires devant les juridictions civiles et/ou pénales.
  </p>

  <h2>
    <strong>10. Données personnelles et témoins de connexion</strong>
  </h2>
  <h3>10.1. Cookies</h3>
  <p>
    Pour plus d'informations sur l'usage des cookies sur notre Site, veuillez vous référer au lien suivant : Politique de gestion des cookies
  </p>

  <h3>10.2. Données personnelles</h3>
  <p>
    Pour plus d'informations sur l'usage de vos données personnelles sur notre Site, veuillez vous référer au lien suivant : Politique de Confidentialité et de Protection des données
  </p>

  <h2>
    <strong>11. Modifications et mises à jour</strong>
  </h2>
  <p>
    La Société se réserve le droit de modifier ses CGU à tout moment, notamment en cas de changement de la réglementation. Les nouvelles dispositions régiront pour l'avenir l'ensemble des relations des Utilisateurs avec la Société et seule la nouvelle version fera foi. Les nouvelles CGU ne seront opposables aux Utilisateurs qu'à partir de leur mise en ligne. Tout usage des services proposés sur le Site après l'entrée en vigueur des modifications vaudra acceptation des CGU ainsi modifiées.
  </p>

  <h2>
    <strong>12. Divers</strong>
  </h2>
  <p>
    Dans l'hypothèse où l'une des dispositions des présentes CGU serait considérée comme nulle en vertu d'une disposition légale et réglementaire ou d'une décision de justice revêtue de l'autorité de la chose jugée, les autres dispositions resteront bien en vigueur. Le fait de ne pas se prévaloir de l'une quelconque des dispositions des présentes, ne pourra être interprété comme valant renonciation à se prévaloir ultérieurement de ladite disposition.
  </p>

  <h2>
    <strong>13. Droit applicable – Litige – Traitement des réclamations – Médiation</strong>
  </h2>
  <p>
    Les présentes CGU sont régies par le droit français.
  </p>
  <p>
    Toutefois, la loi française applicable ne peut avoir pour effet de priver l'Utilisateur résidant dans un autre État membre des dispositions impératives d'ordre public plus favorables que lui accorderait son droit national.
  </p>
  <p>
    En cas de litige ou de réclamation, l'Utilisateur doit s'adresser en priorité au Service Client de WEEDEV SAS à l'adresse suivante : 114, rue Gallieni - 92100 Boulogne-Billancourt ou à l'adresse mail : dpo@hipto.com.
  </p>
  <p>
    WEEDEV SAS répondra dans les meilleurs délais.
  </p>
  <p>
    Si la Société nécessite un délai plus long ou des informations supplémentaires pour répondre à la demande ou la requête de l'Utilisateur, elle en informe ce dernier.
  </p>
  <p>
    En cas d'absence de réponse de la Société l'Utilisateur a la possibilité de recourir à une solution amiable et notamment à une procédure de médiation conventionnelle ou à tout autre mode alternatif de règlement des différends.
  </p>
  <p>
    En particulier, l'Utilisateur et/ou la Société peuvent résoudre un litige par le biais de la plateforme de Résolution des litiges en ligne mise en place par la Commission européenne, accessible à l'adresse suivante : https://webgate.ec.europa.eu/odr/. Depuis cette plate-forme, les parties peuvent déposer un recours en ligne à l'encontre de l'autre, qui en sera informée. L'Utilisateur et la Société choisiront ensemble un organe de résolution extrajudiciaire des conflits auprès duquel la plateforme de Résolution des litiges transmettra le litige.
  </p>
  <p>
    En tout état de cause, l'Utilisateur aura toujours la faculté de saisir le juge. Il peut saisir à son choix, les juridictions de Nanterre (lieu où demeure WEEDEV SAS), les juridictions du lieu où les services ont été ou auraient dû être fournis, ou encore les juridictions du lieu où l'Utilisateur est domicilié au moment de la survenance du fait dommageable.
  </p>

  <p>
    Date de mise à jour<br>27/03/2025
  </p>
</div>
`;
